import RestModule from "../RestModule";

export default new RestModule("libraries", {});
